import { DisplayMessageOnCellTooltipParams } from './types';

const displayMessageOnCellTooltip = <T>(params: DisplayMessageOnCellTooltipParams<T>) => {
  const { addFeedbackFromCell, cell, message } = params;

  addFeedbackFromCell?.(cell, message, '');
};

export default displayMessageOnCellTooltip;
